import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestNewsletterSubscribePost = {
    path: "/newsletter/subscribe",
    method: RouteHttpVerb.POST
};
